import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteRegulationMutationVariables = Types.Exact<{
  input: Types.DeleteRegulationInput;
}>;


export type DeleteRegulationMutation = { __typename?: 'Mutation', deleteRegulation: { __typename?: 'DeleteRegulationPayload', regulation?: { __typename?: 'Regulation', id: string } | null } };


export const DeleteRegulationDocument = gql`
    mutation DeleteRegulation($input: DeleteRegulationInput!) {
  deleteRegulation(input: $input) {
    regulation {
      id
    }
  }
}
    `;
export type DeleteRegulationMutationFn = Apollo.MutationFunction<DeleteRegulationMutation, DeleteRegulationMutationVariables>;

/**
 * __useDeleteRegulationMutation__
 *
 * To run a mutation, you first call `useDeleteRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegulationMutation, { data, loading, error }] = useDeleteRegulationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRegulationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegulationMutation, DeleteRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegulationMutation, DeleteRegulationMutationVariables>(DeleteRegulationDocument, options);
      }
export type DeleteRegulationMutationHookResult = ReturnType<typeof useDeleteRegulationMutation>;
export type DeleteRegulationMutationResult = Apollo.MutationResult<DeleteRegulationMutation>;
export type DeleteRegulationMutationOptions = Apollo.BaseMutationOptions<DeleteRegulationMutation, DeleteRegulationMutationVariables>;